import { updateBookingAsyncResponse } from "./types";
import * as bookingActions from "./actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPut, API_URL_BOOKING, retrieveToken } from "../../../helpers/api";
import { toast } from "react-toastify";

export function* updateBookings(action: ReturnType<typeof bookingActions.updateBookingAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    if (action.payload.id) {
      const result: Response = yield call(apiPut, API_URL_BOOKING.UPDATE_BOOKING(action.payload.id), token, action.payload);
      if (result.status === 200) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        toast.success('Berhasil memperbaharui data pemesanan ruangan.');
        const parsed: updateBookingAsyncResponse = yield call(result.json.bind(result));
        yield put(bookingActions.updateBookingAsync.success(parsed));
        return;
      } else {
        const parsed: ErrorResponse = yield call(result.json.bind(result));
        yield put(bookingActions.updateBookingAsync.failure(parsed));
        return;
      }
    } else {
      const parsed: ErrorResponse = {
        status: 500,
        errors: {},
        message: 'Terjadi kesalahan pada server'
      }
      yield put(bookingActions.updateBookingAsync.failure(parsed));  
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(bookingActions.updateBookingAsync.failure(parsed));
  }
}

export default function* bookingsSagaUpdateBooking() {
  yield takeEvery(bookingActions.updateBookingAsync.request, updateBookings);
}
